import { render } from "./Welcome.vue?vue&type=template&id=e31998fc"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=e31998fc&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__